export default {
      id: "211,8_cm_=_90_+_28,4_+_90-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#211,8_cm_=_90_+_28,4_+_90",
      toString: function () {
        return this.url;
      }
    }